import { render, staticRenderFns } from "./PaginationTableButton.vue?vue&type=template&id=2c730478&scoped=true"
import script from "./PaginationTableButton.vue?vue&type=script&lang=js"
export * from "./PaginationTableButton.vue?vue&type=script&lang=js"
import style0 from "./PaginationTableButton.vue?vue&type=style&index=0&id=2c730478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c730478",
  null
  
)

export default component.exports